import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP context token to suppress self-echo on a list subscription.
 *
 * @description
 * When set on a mutating request, the WebSocket interceptor sends
 * `WEBSOCKET_EXCLUDE_SUBSCRIPTION_ID` so the originating client
 * does not receive its own list opinion for that subscription.
 *
 * @example
 * ```typescript
 * const { subscriptionId } = ws.subscribeList({ subject, filters });
 * http.patch(url, body, {
 *   context: new HttpContext().set(WS_EXCLUDE_SUBSCRIPTION_ID, subscriptionId),
 * });
 * ```
 */
export const WS_EXCLUDE_SUBSCRIPTION_ID = new HttpContextToken<
  string | undefined
>(() => undefined);
